<script>

import server from "@/components/ServerApi";
import constants from "@/components/constants";
import commonUtil from "@/components/commonutil";

export default class {
    constructor(i18n, notify) {
        this.$i18n = i18n
        this.$notify = notify

        //TODO: this variable is should be remove after complete to refactor of the behavior of appData;
        this.appData = null

        this.store = {
            tenantId: null,
            countryCode: {
                alpha2: "",
                alpha3: ""
            },
            tenantList: null,
            processorTemplateList: [],
            processorDefinitionList: [],
            serviceInformationList: [],

            needRefreshOfProcessorTemplate: false,

            actions: {
                fetchTenants: async () => this.fetchTenants(),
                fetchProcessorTemplatesAndDefinitions: async () => this.fetchProcessorTemplatesAndDefinitions(),
                fetchServiceInformations: async () => this.fetchServiceInformations()
            }
        }
    }

    async fetchTenants() {
        try {
            const res = await server.post('/gettenants')
            this.store.tenantList = res.data.tenants
            this.store.tenantId = this.store.tenantList[0].tenantId

            const countryCodeAlpha3 = this.store.tenantList[0].countryCode
            this.store.countryCode.alpha3 = countryCodeAlpha3
            let countryCode = commonUtil.getCountryList().find(item => item.value === countryCodeAlpha3)
            this.store.countryCode.alpha2 = countryCode.alpha2;
        } catch (error) {
            commonUtil.putExceptionErrorMessage(this, "fetchTenants", error);
        }
    }

    async fetchProcessorTemplatesAndDefinitions() {
        this.needRefreshOfProcessorTemplate = false;
        try {
            const res = await server.post('/getprocessortemplatesanddefinitions')

            switch (res.data.status) {
                case constants.STATUS_SUCCESS:
                    this.store.processorTemplateList = res.data.templates;
                    this.store.processorDefinitionList = res.data.definitions;
                    break;
                default:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","fetchProcessorTemplatesAndDefinitions").replace("{code}",res.data.status));
                    break;
            }
        } catch (error ) {
            commonUtil.putExceptionErrorMessage(this, "fetchProcessorTemplatesAndDefinitions", error);
        }
    }

    async fetchServiceInformations() {
        try {
            const res = await server.post('/getserviceinformations')

            switch (res.data.status) {
                case constants.STATUS_SUCCESS:
                    this.store.serviceInformationList = res.data.serviceInformations;
                    break;
                case constants.STATUS_ERROR_PERMISSION_DENIED:
                    this.store.serviceInformationList = []
                    break;
                default:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","fetchServiceInformations").replace("{code}", res.data.status));
                    break;
            }
        } catch (error) {
            commonUtil.putExceptionErrorMessage(this, "fetchServiceInformations", error);
        }
    }
}

</script>

